"use client";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertCircle, AlertTriangle, Ban, Check, ChevronDown, ChevronLeft, ChevronRight, Code, Copy, Eye, Gift, Globe, MessageSquare, Wrench, Zap, Search, Filter, X, ArrowUpDown, ArrowUp, ArrowDown, Video, ImagePlus, ExternalLink, Gem, Percent, Scale, Braces, FileJson2, List, Grid, Bot, Boxes, Brain, Sparkles, PenTool, Sliders, Volume2, Mic, ListOrdered } from "lucide-react";
import Link from "next/link.js";
import { usePathname, useRouter, useSearchParams } from "next/navigation.js";
import React, { useMemo, useState, useCallback, useEffect } from "react";
import { getProviderIcon } from "../provider-icons.js";
import { Badge } from "../ui/badge.js";
import { Button } from "../ui/button.js";
import { Card, CardContent } from "../ui/card.js";
import { Input } from "../ui/input.js";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select.js";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table.js";
import { Toggle } from "../ui/toggle.js";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip.js";
import { cn } from "../../lib/utils.js";
import { isMappingDeactivated } from "./deactivation.js";
import { formatDeprecationDate } from "./format.js";
import { ModelCard } from "./model-card.js";
import { applyCategoryFilter } from "./model-category-filters.js";
import { useIsMobile } from "./use-mobile.js";
function computeCapabilities(provider, model) {
  var _a, _b, _c, _d, _e;
  var capabilities = [];
  if (provider.streaming) {
    capabilities.push({
      icon: Zap,
      label: "Streaming",
      color: "text-blue-500"
    });
  }
  if (provider.vision) {
    capabilities.push({
      icon: Eye,
      label: "Vision",
      color: "text-green-500"
    });
  }
  if (provider.tools) {
    capabilities.push({
      icon: Wrench,
      label: "Tools",
      color: "text-purple-500"
    });
  }
  if (provider.reasoning) {
    capabilities.push({
      icon: MessageSquare,
      label: "Reasoning",
      color: "text-orange-500"
    });
  }
  if (provider.reasoningMaxTokens) {
    capabilities.push({
      icon: Sliders,
      label: "Reasoning Budget",
      color: "text-amber-500"
    });
  }
  if (provider.jsonOutput) {
    capabilities.push({
      icon: Braces,
      label: "JSON Output",
      color: "text-cyan-500"
    });
  }
  if (provider.jsonOutputSchema) {
    capabilities.push({
      icon: FileJson2,
      label: "Structured JSON",
      color: "text-teal-500"
    });
  }
  if ((_a = model === null || model === void 0 ? void 0 : model.output) === null || _a === void 0 ? void 0 : _a.includes("image")) {
    capabilities.push({
      icon: ImagePlus,
      label: "Image Generation",
      color: "text-pink-500"
    });
  }
  if ((_b = model === null || model === void 0 ? void 0 : model.output) === null || _b === void 0 ? void 0 : _b.includes("video")) {
    capabilities.push({
      icon: Video,
      label: "Video Generation",
      color: "text-violet-500"
    });
  }
  if ((_c = model === null || model === void 0 ? void 0 : model.output) === null || _c === void 0 ? void 0 : _c.includes("audio")) {
    capabilities.push({
      icon: Volume2,
      label: "Speech Generation",
      color: "text-rose-500"
    });
  }
  if ((_d = model === null || model === void 0 ? void 0 : model.output) === null || _d === void 0 ? void 0 : _d.includes("transcription")) {
    capabilities.push({
      icon: Mic,
      label: "Transcription",
      color: "text-sky-500"
    });
  }
  if ((_e = model === null || model === void 0 ? void 0 : model.output) === null || _e === void 0 ? void 0 : _e.includes("embedding")) {
    capabilities.push({
      icon: Boxes,
      label: "Embeddings",
      color: "text-indigo-500"
    });
  }
  if (provider.webSearch) {
    capabilities.push({
      icon: Globe,
      label: "Web Search",
      color: "text-sky-500"
    });
  }
  return capabilities;
}
var ModelTableRow = React.memo(function (_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var row = _a.row,
    isExpanded = _a.isExpanded,
    copiedModel = _a.copiedModel,
    onToggleExpand = _a.onToggleExpand,
    onCopy = _a.onCopy,
    onNavigate = _a.onNavigate,
    formatPrice = _a.formatPrice,
    modelHref = _a.modelHref;
  var ProviderIcon = row.ProviderIcon;
  var isCustom = row.model.source === "custom";
  var blockedReasons = (_b = row.provider.blockedReasons) !== null && _b !== void 0 ? _b : [];
  var isBlocked = blockedReasons.length > 0;
  return _jsxs(_Fragment, {
    children: [_jsxs(TableRow, {
      className: cn("hover:bg-muted/50 transition-colors", isCustom ? "cursor-default" : "cursor-pointer", isBlocked && "opacity-60"),
      onClick: onNavigate,
      children: [_jsx(TableCell, {
        className: "font-medium",
        children: _jsxs("div", {
          className: "flex items-center gap-2",
          children: [row.hasAdditionalPricing ? _jsx("button", {
            onClick: function (e) {
              e.stopPropagation();
              onToggleExpand();
            },
            className: "p-0.5 hover:bg-muted rounded",
            "aria-label": "Toggle additional pricing details",
            "aria-expanded": isExpanded,
            children: isExpanded ? _jsx(ChevronDown, {
              className: "h-4 w-4 text-muted-foreground"
            }) : _jsx(ChevronRight, {
              className: "h-4 w-4 text-muted-foreground"
            })
          }) : _jsx("div", {
            className: "w-5 h-5"
          }), ProviderIcon ? _jsx(ProviderIcon, {
            className: "w-4 h-4"
          }) : _jsx("div", {
            className: "w-4 h-4 rounded-sm flex items-center justify-center text-xs font-medium text-white",
            style: {
              backgroundColor: (_d = (_c = row.providerInfo) === null || _c === void 0 ? void 0 : _c.color) !== null && _d !== void 0 ? _d : "#6b7280"
            },
            children: ((_f = (_e = row.providerInfo) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : row.provider.providerId).charAt(0).toUpperCase()
          }), isCustom ? _jsx("span", {
            className: "text-sm",
            children: (_h = (_g = row.providerInfo) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : row.provider.providerId
          }) : _jsxs(Link, {
            href: modelHref("/models/".concat(encodeURIComponent(row.model.id), "/").concat(row.provider.providerId)),
            onClick: function (e) {
              return e.stopPropagation();
            },
            className: "text-sm hover:text-primary hover:underline",
            children: [(_k = (_j = row.providerInfo) === null || _j === void 0 ? void 0 : _j.name) !== null && _k !== void 0 ? _k : row.provider.providerId, row.provider.region && _jsxs("span", {
              className: "text-muted-foreground text-xs ml-1",
              children: ["(", row.provider.region, ")"]
            })]
          }), isCustom && _jsx(Badge, {
            variant: "outline",
            className: "text-[10px] px-1.5 py-0 shrink-0",
            children: "Custom"
          }), isBlocked && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(Ban, {
                  className: "h-3.5 w-3.5 text-red-500"
                })
              })
            }), _jsxs(TooltipContent, {
              className: "max-w-xs",
              children: [_jsx("p", {
                className: "text-xs font-medium mb-1",
                children: "Not available under your organization's compliance policy:"
              }), _jsx("ul", {
                className: cn("text-xs", blockedReasons.length > 1 && "list-disc pl-4 space-y-0.5"),
                children: blockedReasons.map(function (reason) {
                  return _jsx("li", {
                    children: reason
                  }, reason);
                })
              })]
            })]
          }), row.provider.deactivatedAt && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(AlertCircle, {
                  className: "h-3.5 w-3.5 text-red-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: formatDeprecationDate(row.provider.deactivatedAt, "deactivated")
              })
            })]
          }), !row.provider.deactivatedAt && row.provider.deprecatedAt && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(AlertTriangle, {
                  className: "h-3.5 w-3.5 text-amber-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: formatDeprecationDate(row.provider.deprecatedAt, "deprecated")
              })
            })]
          }), !isCustom && _jsx(ExternalLink, {
            className: "h-3 w-3 text-muted-foreground"
          })]
        })
      }), _jsx(TableCell, {
        children: _jsxs("div", {
          className: "flex items-center gap-2",
          children: [isCustom ? _jsx("span", {
            className: "font-medium text-sm",
            children: row.model.id
          }) : _jsx(Link, {
            href: modelHref("/models/".concat(encodeURIComponent(row.model.id))),
            onClick: function (e) {
              return e.stopPropagation();
            },
            className: "font-medium text-sm hover:text-primary hover:underline",
            children: row.model.id
          }), row.model.premium && _jsxs(Tooltip, {
            children: [_jsx(TooltipTrigger, {
              asChild: true,
              children: _jsx("span", {
                className: "shrink-0 cursor-help",
                children: _jsx(Gem, {
                  className: "h-3.5 w-3.5 text-amber-500"
                })
              })
            }), _jsx(TooltipContent, {
              children: _jsx("p", {
                className: "text-xs",
                children: "Premium tier \u2014 $5+/M input or $15+/M output. Subject to the weekly fair-use allowance on DevPass plans."
              })
            })]
          }), _jsx("button", {
            onClick: function (e) {
              var fullId = isCustom ? row.model.id : row.provider.region ? "".concat(row.provider.providerId, "/").concat(row.model.id, ":").concat(row.provider.region) : "".concat(row.provider.providerId, "/").concat(row.model.id);
              onCopy(fullId, row.rowKey, e);
            },
            className: "p-1 hover:bg-muted rounded transition-colors",
            title: copiedModel === row.rowKey ? "Copied!" : "Copy model ID",
            children: copiedModel === row.rowKey ? _jsx(Check, {
              className: "h-3 w-3 text-green-500"
            }) : _jsx(Copy, {
              className: "h-3 w-3 text-muted-foreground"
            })
          })]
        })
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: row.provider.perSecondPrice && !row.provider.inputPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsx("span", {
              className: "text-violet-500 cursor-help",
              children: function () {
                var prices = row.provider.perSecondPrice;
                var values = Object.values(prices).map(Number).filter(Number.isFinite);
                if (values.length === 0) {
                  return "—";
                }
                var min = Math.min.apply(Math, values);
                return "$".concat(min, "/sec");
              }()
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Video per-second pricing"
            })
          })]
        }) : (!row.provider.inputPrice || parseFloat(row.provider.inputPrice) === 0) && row.provider.inputCharacterPrice && parseFloat(row.provider.inputCharacterPrice) > 0 ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-sky-500 cursor-help",
              children: ["$", parseFloat((parseFloat(row.provider.inputCharacterPrice) * 1000).toFixed(4)), "/1K chars"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-character pricing (not per token)"
            })
          })]
        }) : (!row.provider.inputPrice || parseFloat(row.provider.inputPrice) === 0) && row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsxs("span", {
              className: "text-amber-500 cursor-help",
              children: ["$", parseFloat(row.provider.requestPrice).toFixed(3), "/req"]
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Per-request pricing (not per token)"
            })
          })]
        }) : formatPrice(row.provider.inputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: row.provider.perSecondPrice && !row.provider.outputPrice ? _jsxs(Tooltip, {
          children: [_jsx(TooltipTrigger, {
            asChild: true,
            children: _jsx("span", {
              className: "text-violet-500 cursor-help",
              children: function () {
                var prices = row.provider.perSecondPrice;
                var values = Object.values(prices).map(Number).filter(Number.isFinite);
                if (values.length === 0) {
                  return "—";
                }
                var max = Math.max.apply(Math, values);
                return "$".concat(max, "/sec");
              }()
            })
          }), _jsx(TooltipContent, {
            children: _jsx("p", {
              className: "text-xs",
              children: "Video per-second pricing"
            })
          })]
        }) : (!row.provider.outputPrice || parseFloat(row.provider.outputPrice) === 0) && (row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 || row.provider.inputCharacterPrice && parseFloat(row.provider.inputCharacterPrice) > 0) ? _jsx("span", {
          className: "text-muted-foreground",
          children: "\u2014"
        }) : formatPrice(row.provider.outputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-right font-mono text-sm",
        children: formatPrice(row.provider.cachedInputPrice, row.provider.discount)
      }), _jsx(TableCell, {
        className: "text-center",
        children: _jsx("div", {
          className: "flex justify-center gap-1",
          children: row.capabilities.slice(0, 4).map(function (_a) {
            var Icon = _a.icon,
              label = _a.label,
              color = _a.color;
            return _jsx("div", {
              className: "p-0.5",
              title: label,
              children: _jsx(Icon, {
                className: "h-4 w-4 ".concat(color)
              })
            }, label);
          })
        })
      })]
    }), isExpanded && row.hasAdditionalPricing && _jsx(TableRow, {
      className: "bg-muted/30",
      children: _jsx(TableCell, {
        colSpan: 6,
        className: "py-3",
        children: _jsxs("div", {
          className: "pl-8",
          children: [_jsx("div", {
            className: "text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-2",
            children: "Additional Pricing"
          }), _jsxs("div", {
            className: "flex gap-3",
            children: [row.provider.webSearch && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: [_jsx(Globe, {
                className: "h-4 w-4 mr-2 text-purple-500"
              }), "Web Search", row.provider.webSearchPrice && parseFloat(row.provider.webSearchPrice) > 0 && " $".concat(parseFloat(row.provider.webSearchPrice).toFixed(3), "/search")]
            }), row.provider.requestPrice && parseFloat(row.provider.requestPrice) > 0 && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: ["Per Request $", parseFloat(row.provider.requestPrice).toFixed(3)]
            }), row.provider.perSecondPrice && Object.keys(row.provider.perSecondPrice).length > 0 && _jsxs(Badge, {
              variant: "outline",
              className: "text-sm px-3 py-1.5 bg-background",
              children: [_jsx(Video, {
                className: "h-4 w-4 mr-2 text-violet-500"
              }), "Video", " ", function () {
                var prices = row.provider.perSecondPrice;
                var defaultVideo = prices["default_video"];
                var defaultAudio = prices["default_audio"];
                var defaultPrice = prices["default"];
                if (defaultVideo && defaultAudio) {
                  return "$".concat(defaultVideo, " \u2013 $").concat(defaultAudio, "/sec");
                }
                if (defaultPrice) {
                  return "$".concat(defaultPrice, "/sec");
                }
                var firstValue = Object.values(prices)[0];
                return firstValue ? "$".concat(firstValue, "/sec") : "";
              }()]
            })]
          })]
        })
      })
    })]
  });
});
var MODELS_PER_PAGE = 50;
export function AllModels(_a) {
  var _this = this;
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
  var children = _a.children,
    models = _a.models,
    providers = _a.providers,
    title = _a.title,
    description = _a.description,
    categoryFilter = _a.categoryFilter,
    seoContent = _a.seoContent,
    footer = _a.footer,
    renderCta = _a.renderCta,
    _o = _a.modelHrefBase,
    modelHrefBase = _o === void 0 ? "" : _o,
    _p = _a.showPricingTierFilter,
    showPricingTierFilter = _p === void 0 ? false : _p,
    _q = _a.defaultCategory,
    defaultCategory = _q === void 0 ? "all" : _q,
    _r = _a.hideUseCaseFilter,
    hideUseCaseFilter = _r === void 0 ? false : _r,
    _s = _a.hideHeader,
    hideHeader = _s === void 0 ? false : _s;
  var router = useRouter();
  var pathname = usePathname();
  var searchParams = useSearchParams();
  var isMobile = useIsMobile();
  var modelHref = function (path) {
    return "".concat(modelHrefBase).concat(path);
  };
  var _t = useState(searchParams.get("view") === "grid" ? "grid" : "table"),
    viewMode = _t[0],
    setViewMode = _t[1];
  useEffect(function () {
    var viewParam = searchParams.get("view");
    if (!viewParam && isMobile && viewMode !== "grid") {
      setViewMode("grid");
    }
  }, [isMobile, searchParams, viewMode]);
  var _u = useState(new Set()),
    expandedRows = _u[0],
    setExpandedRows = _u[1];
  var _v = useState(null),
    copiedModel = _v[0],
    setCopiedModel = _v[1];
  var _w = useState((_b = searchParams.get("q")) !== null && _b !== void 0 ? _b : ""),
    searchQuery = _w[0],
    setSearchQuery = _w[1];
  var _x = useState(searchParams.get("filters") === "1"),
    showFilters = _x[0],
    setShowFilters = _x[1];
  var _y = useState(searchParams.get("sortField") || null),
    sortField = _y[0],
    setSortField = _y[1];
  var _z = useState(searchParams.get("sortDir") === "desc" ? "desc" : "asc"),
    sortDirection = _z[0],
    setSortDirection = _z[1];
  var _0 = useState({
      category: hideUseCaseFilter ? defaultCategory : (_c = searchParams.get("category")) !== null && _c !== void 0 ? _c : defaultCategory,
      tier: (_d = searchParams.get("tier")) !== null && _d !== void 0 ? _d : "all",
      capabilities: {
        streaming: searchParams.get("streaming") === "true",
        vision: searchParams.get("vision") === "true",
        tools: searchParams.get("tools") === "true",
        reasoning: searchParams.get("reasoning") === "true",
        reasoningBudget: searchParams.get("reasoningBudget") === "true",
        jsonOutput: searchParams.get("jsonOutput") === "true",
        jsonOutputSchema: searchParams.get("jsonOutputSchema") === "true",
        imageGeneration: searchParams.get("imageGeneration") === "true",
        videoGeneration: searchParams.get("videoGeneration") === "true",
        audioGeneration: searchParams.get("audioGeneration") === "true",
        embedding: searchParams.get("embedding") === "true",
        rerank: searchParams.get("rerank") === "true",
        webSearch: searchParams.get("webSearch") === "true",
        free: searchParams.get("free") === "true",
        discounted: searchParams.get("discounted") === "true"
      },
      selectedProvider: (_e = searchParams.get("provider")) !== null && _e !== void 0 ? _e : "all",
      showDeactivated: searchParams.get("deactivated") === "true",
      source: (_f = searchParams.get("source")) !== null && _f !== void 0 ? _f : "all",
      eligibleOnly: searchParams.get("eligibility") === "eligible",
      inputPrice: {
        min: (_g = searchParams.get("inputPriceMin")) !== null && _g !== void 0 ? _g : "",
        max: (_h = searchParams.get("inputPriceMax")) !== null && _h !== void 0 ? _h : ""
      },
      outputPrice: {
        min: (_j = searchParams.get("outputPriceMin")) !== null && _j !== void 0 ? _j : "",
        max: (_k = searchParams.get("outputPriceMax")) !== null && _k !== void 0 ? _k : ""
      },
      contextSize: {
        min: (_l = searchParams.get("contextSizeMin")) !== null && _l !== void 0 ? _l : "",
        max: (_m = searchParams.get("contextSizeMax")) !== null && _m !== void 0 ? _m : ""
      }
    }),
    filters = _0[0],
    setFilters = _0[1];
  var hasCustomModels = useMemo(function () {
    return models.some(function (model) {
      return model.source === "custom";
    });
  }, [models]);
  var hasBlockedMappings = useMemo(function () {
    return models.some(function (model) {
      return model.mappings.some(function (mapping) {
        var _a;
        return (_a = mapping.blockedReasons) === null || _a === void 0 ? void 0 : _a.length;
      });
    });
  }, [models]);
  var updateUrlWithFilters = useCallback(function (newParams) {
    var params = new URLSearchParams(searchParams.toString());
    Object.entries(newParams).forEach(function (_a) {
      var key = _a[0],
        value = _a[1];
      if (value !== undefined && value !== "") {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    router.replace("?".concat(params.toString()), {
      scroll: false
    });
  }, [router, searchParams]);
  var _1 = useMemo(function () {
      var now = new Date();
      var visibleModelCount = models.filter(function (model) {
        return model.mappings.some(function (mapping) {
          if (mapping.deprecatedAt && new Date(mapping.deprecatedAt) <= now) {
            return false;
          }
          return filters.showDeactivated || !isMappingDeactivated(mapping, now);
        });
      }).length;
      return {
        totalModelCount: visibleModelCount,
        totalProviderCount: providers.length
      };
    }, [models, providers, filters.showDeactivated]),
    totalModelCount = _1.totalModelCount,
    totalProviderCount = _1.totalProviderCount;
  var modelsWithProviders = useMemo(function () {
    var now = new Date();
    var baseModels = models.filter(function (model) {
      if (filters.source === "custom") {
        return model.source === "custom";
      }
      if (filters.source === "catalog") {
        return model.source !== "custom";
      }
      return true;
    }).map(function (model) {
      var visibleMappings = model.mappings.filter(function (mapping) {
        var _a;
        if (mapping.deprecatedAt && new Date(mapping.deprecatedAt) <= now) {
          return false;
        }
        if (!filters.showDeactivated && isMappingDeactivated(mapping, now)) {
          return false;
        }
        if (filters.eligibleOnly && ((_a = mapping.blockedReasons) === null || _a === void 0 ? void 0 : _a.length)) {
          return false;
        }
        return true;
      });
      return __assign(__assign({}, model), {
        providerDetails: visibleMappings.map(function (mapping) {
          return {
            provider: mapping,
            providerInfo: providers.find(function (p) {
              return p.id === mapping.providerId;
            })
          };
        })
      });
    }).filter(function (model) {
      return model.providerDetails.length > 0;
    });
    var preFilteredModels = categoryFilter ? baseModels.filter(function (model) {
      return applyCategoryFilter(categoryFilter, model, model.providerDetails.map(function (p) {
        return p.provider;
      }));
    }) : baseModels;
    var filteredModels = preFilteredModels.filter(function (model) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
      if (searchQuery) {
        var normalize = function (str) {
          return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
        };
        var queryTokens = searchQuery.trim().toLowerCase().split(/\s+/).map(function (t) {
          return t.replace(/[^a-z0-9]/g, "");
        }).filter(Boolean);
        var providerStrings = ((_a = model.providerDetails) !== null && _a !== void 0 ? _a : []).flatMap(function (p) {
          var _a, _b;
          return [p.provider.providerId, (_b = (_a = p.providerInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ""];
        });
        var haystackParts = __spreadArray(__spreadArray([(_b = model.name) !== null && _b !== void 0 ? _b : "", model.id, model.family], (_c = model.aliases) !== null && _c !== void 0 ? _c : [], true), providerStrings, true);
        var haystack_1 = normalize(haystackParts.join(" "));
        var normalizedQuery = normalize(searchQuery);
        var containsAllTokens = queryTokens.every(function (t) {
          return haystack_1.includes(t);
        });
        var containsPhrase = normalizedQuery ? haystack_1.includes(normalizedQuery) : true;
        if (!(containsAllTokens || containsPhrase)) {
          return false;
        }
      }
      if (filters.category && filters.category !== "all") {
        switch (filters.category) {
          case "code":
            {
              if (model.free) {
                return false;
              }
              if (model.stability === "unstable" || model.stability === "experimental") {
                return false;
              }
              var hasCodeCapabilities = model.providerDetails.some(function (p) {
                var _a;
                return ((_a = p.provider.jsonOutput) !== null && _a !== void 0 ? _a : p.provider.jsonOutputSchema) && p.provider.tools && p.provider.streaming && p.provider.cachedInputPrice !== null;
              });
              if (!hasCodeCapabilities) {
                return false;
              }
              break;
            }
          case "chat":
            {
              var hasStreaming = model.providerDetails.some(function (p) {
                return p.provider.streaming && p.provider.cachedInputPrice !== null;
              });
              if (!hasStreaming) {
                return false;
              }
              break;
            }
          case "reasoning":
            {
              var hasReasoning = model.providerDetails.some(function (p) {
                return p.provider.reasoning;
              });
              if (!hasReasoning) {
                return false;
              }
              break;
            }
          case "creative":
            {
              if ((_d = model.output) === null || _d === void 0 ? void 0 : _d.includes("image")) {
                return false;
              }
              var hasCreativeStreaming = model.providerDetails.some(function (p) {
                return p.provider.streaming;
              });
              if (!hasCreativeStreaming) {
                return false;
              }
              break;
            }
          case "image":
            {
              if (!((_e = model.output) === null || _e === void 0 ? void 0 : _e.includes("image"))) {
                return false;
              }
              break;
            }
          case "multimodal":
            {
              var hasVision = model.providerDetails.some(function (p) {
                return p.provider.vision;
              });
              if (!hasVision) {
                return false;
              }
              break;
            }
        }
      }
      if (filters.tier === "premium" && !model.premium) {
        return false;
      }
      if (filters.tier === "standard" && model.premium) {
        return false;
      }
      if (filters.capabilities.streaming && !model.providerDetails.some(function (p) {
        return p.provider.streaming;
      })) {
        return false;
      }
      if (filters.capabilities.vision && !model.providerDetails.some(function (p) {
        return p.provider.vision;
      })) {
        return false;
      }
      if (filters.capabilities.tools && !model.providerDetails.some(function (p) {
        return p.provider.tools;
      })) {
        return false;
      }
      if (filters.capabilities.reasoning && !model.providerDetails.some(function (p) {
        return p.provider.reasoning;
      })) {
        return false;
      }
      if (filters.capabilities.reasoningBudget && !model.providerDetails.some(function (p) {
        return p.provider.reasoningMaxTokens;
      })) {
        return false;
      }
      if (filters.capabilities.jsonOutput && !model.providerDetails.some(function (p) {
        return p.provider.jsonOutput;
      })) {
        return false;
      }
      if (filters.capabilities.jsonOutputSchema && !model.providerDetails.some(function (p) {
        return p.provider.jsonOutputSchema;
      })) {
        return false;
      }
      if (filters.capabilities.imageGeneration && !((_f = model.output) === null || _f === void 0 ? void 0 : _f.includes("image"))) {
        return false;
      }
      if (filters.capabilities.videoGeneration && !((_g = model.output) === null || _g === void 0 ? void 0 : _g.includes("video"))) {
        return false;
      }
      if (filters.capabilities.audioGeneration && !((_h = model.output) === null || _h === void 0 ? void 0 : _h.includes("audio"))) {
        return false;
      }
      if (filters.capabilities.embedding && !((_j = model.output) === null || _j === void 0 ? void 0 : _j.includes("embedding"))) {
        return false;
      }
      if (filters.capabilities.rerank && !((_k = model.output) === null || _k === void 0 ? void 0 : _k.includes("rerank"))) {
        return false;
      }
      if (filters.capabilities.webSearch && !model.providerDetails.some(function (p) {
        return p.provider.webSearch;
      })) {
        return false;
      }
      if (filters.capabilities.free) {
        var hasRequestPrice = model.providerDetails.some(function (p) {
          return p.provider.requestPrice && parseFloat(p.provider.requestPrice) > 0;
        });
        if (!model.free || hasRequestPrice) {
          return false;
        }
      }
      if (filters.capabilities.discounted && !model.providerDetails.some(function (p) {
        return p.provider.discount && parseFloat(p.provider.discount) > 0;
      })) {
        return false;
      }
      if (filters.selectedProvider && filters.selectedProvider !== "all") {
        var hasSelectedProvider = model.providerDetails.some(function (p) {
          return p.provider.providerId === filters.selectedProvider;
        });
        if (!hasSelectedProvider) {
          return false;
        }
      }
      var hasInputPrice = function (min, max) {
        return model.providerDetails.some(function (p) {
          if (p.provider.inputPrice === null || p.provider.inputPrice === undefined) {
            return !min && !max;
          }
          var price = parseFloat(p.provider.inputPrice) * 1e6;
          var minPrice = min ? parseFloat(min) : 0;
          var maxPrice = max ? parseFloat(max) : Infinity;
          return price >= minPrice && price <= maxPrice;
        });
      };
      var hasOutputPrice = function (min, max) {
        return model.providerDetails.some(function (p) {
          if (p.provider.outputPrice === null || p.provider.outputPrice === undefined) {
            return !min && !max;
          }
          var price = parseFloat(p.provider.outputPrice) * 1e6;
          var minPrice = min ? parseFloat(min) : 0;
          var maxPrice = max ? parseFloat(max) : Infinity;
          return price >= minPrice && price <= maxPrice;
        });
      };
      var hasContextSize = function (min, max) {
        return model.providerDetails.some(function (p) {
          if (p.provider.contextSize === null || p.provider.contextSize === undefined) {
            return !min && !max;
          }
          var size = p.provider.contextSize;
          var minSize = min ? parseInt(min, 10) : 0;
          var maxSize = max ? parseInt(max, 10) : Infinity;
          return size >= minSize && size <= maxSize;
        });
      };
      if ((filters.inputPrice.min || filters.inputPrice.max) && !hasInputPrice(filters.inputPrice.min, filters.inputPrice.max)) {
        return false;
      }
      if ((filters.outputPrice.min || filters.outputPrice.max) && !hasOutputPrice(filters.outputPrice.min, filters.outputPrice.max)) {
        return false;
      }
      if ((filters.contextSize.min || filters.contextSize.max) && !hasContextSize(filters.contextSize.min, filters.contextSize.max)) {
        return false;
      }
      return true;
    });
    return __spreadArray([], filteredModels, true).sort(function (a, b) {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
      if (!sortField) {
        var aDate = a.createdAt ? new Date(a.createdAt).getTime() : a.releasedAt ? new Date(a.releasedAt).getTime() : 0;
        var bDate = b.createdAt ? new Date(b.createdAt).getTime() : b.releasedAt ? new Date(b.releasedAt).getTime() : 0;
        return bDate - aDate;
      }
      var aValue;
      var bValue;
      switch (sortField) {
        case "provider":
          aValue = ((_e = (_c = (_b = (_a = a.providerDetails[0]) === null || _a === void 0 ? void 0 : _a.providerInfo) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : (_d = a.providerDetails[0]) === null || _d === void 0 ? void 0 : _d.provider.providerId) !== null && _e !== void 0 ? _e : "").toLowerCase();
          bValue = ((_k = (_h = (_g = (_f = b.providerDetails[0]) === null || _f === void 0 ? void 0 : _f.providerInfo) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : (_j = b.providerDetails[0]) === null || _j === void 0 ? void 0 : _j.provider.providerId) !== null && _k !== void 0 ? _k : "").toLowerCase();
          break;
        case "name":
          aValue = ((_l = a.name) !== null && _l !== void 0 ? _l : a.id).toLowerCase();
          bValue = ((_m = b.name) !== null && _m !== void 0 ? _m : b.id).toLowerCase();
          break;
        case "inputPrice":
          {
            var aInputPrices = a.providerDetails.map(function (p) {
              return p.provider.inputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            var bInputPrices = b.providerDetails.map(function (p) {
              return p.provider.inputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            aValue = aInputPrices.length > 0 ? Math.min.apply(Math, aInputPrices) : Infinity;
            bValue = bInputPrices.length > 0 ? Math.min.apply(Math, bInputPrices) : Infinity;
            break;
          }
        case "outputPrice":
          {
            var aOutputPrices = a.providerDetails.map(function (p) {
              return p.provider.outputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            var bOutputPrices = b.providerDetails.map(function (p) {
              return p.provider.outputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            aValue = aOutputPrices.length > 0 ? Math.min.apply(Math, aOutputPrices) : Infinity;
            bValue = bOutputPrices.length > 0 ? Math.min.apply(Math, bOutputPrices) : Infinity;
            break;
          }
        case "cachedInputPrice":
          {
            var aCachedInputPrices = a.providerDetails.map(function (p) {
              return p.provider.cachedInputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            var bCachedInputPrices = b.providerDetails.map(function (p) {
              return p.provider.cachedInputPrice;
            }).filter(function (p) {
              return p !== null && p !== undefined;
            }).map(function (p) {
              return parseFloat(p);
            });
            aValue = aCachedInputPrices.length > 0 ? Math.min.apply(Math, aCachedInputPrices) : Infinity;
            bValue = bCachedInputPrices.length > 0 ? Math.min.apply(Math, bCachedInputPrices) : Infinity;
            break;
          }
        default:
          return 0;
      }
      if (aValue < bValue) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  }, [searchQuery, filters, sortField, sortDirection, models, providers, categoryFilter]);
  var filteredProviderCount = useMemo(function () {
    var uniqueProviders = new Set(modelsWithProviders.flatMap(function (model) {
      return model.providerDetails.map(function (p) {
        return p.provider.providerId;
      });
    }));
    return uniqueProviders.size;
  }, [modelsWithProviders]);
  var flattenedRows = useMemo(function () {
    var _a;
    var rows = [];
    var providerFilter = filters.selectedProvider && filters.selectedProvider !== "all" ? filters.selectedProvider : null;
    for (var _i = 0, modelsWithProviders_1 = modelsWithProviders; _i < modelsWithProviders_1.length; _i++) {
      var model = modelsWithProviders_1[_i];
      for (var _b = 0, _c = model.providerDetails; _b < _c.length; _b++) {
        var _d = _c[_b],
          provider = _d.provider,
          providerInfo = _d.providerInfo;
        if (providerFilter && provider.providerId !== providerFilter) {
          continue;
        }
        var hasAdditionalPricing = provider.webSearch === true || provider.requestPrice !== null && provider.requestPrice !== undefined && parseFloat(provider.requestPrice) > 0 || provider.perSecondPrice !== null && provider.perSecondPrice !== undefined && Object.values(provider.perSecondPrice).some(function (price) {
          return parseFloat(price) > 0;
        });
        rows.push({
          model: model,
          provider: provider,
          providerInfo: providerInfo,
          hasAdditionalPricing: hasAdditionalPricing,
          rowKey: "".concat(provider.providerId, "-").concat(model.id, "-").concat((_a = provider.region) !== null && _a !== void 0 ? _a : ""),
          capabilities: computeCapabilities(provider, model),
          ProviderIcon: getProviderIcon(provider.providerId)
        });
      }
    }
    return rows.sort(function (a, b) {
      var _a, _b, _c, _d, _e, _f;
      if (!sortField) {
        var aDate = a.model.createdAt ? new Date(a.model.createdAt).getTime() : a.model.releasedAt ? new Date(a.model.releasedAt).getTime() : 0;
        var bDate = b.model.createdAt ? new Date(b.model.createdAt).getTime() : b.model.releasedAt ? new Date(b.model.releasedAt).getTime() : 0;
        return bDate - aDate;
      }
      var aValue;
      var bValue;
      switch (sortField) {
        case "provider":
          aValue = ((_b = (_a = a.providerInfo) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : a.provider.providerId).toLowerCase();
          bValue = ((_d = (_c = b.providerInfo) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : b.provider.providerId).toLowerCase();
          break;
        case "name":
          aValue = ((_e = a.model.name) !== null && _e !== void 0 ? _e : a.model.id).toLowerCase();
          bValue = ((_f = b.model.name) !== null && _f !== void 0 ? _f : b.model.id).toLowerCase();
          break;
        case "inputPrice":
          {
            var aPrice = a.provider.inputPrice;
            var bPrice = b.provider.inputPrice;
            aValue = aPrice !== null && aPrice !== undefined ? parseFloat(aPrice) : Infinity;
            bValue = bPrice !== null && bPrice !== undefined ? parseFloat(bPrice) : Infinity;
            break;
          }
        case "outputPrice":
          {
            var aPrice = a.provider.outputPrice;
            var bPrice = b.provider.outputPrice;
            aValue = aPrice !== null && aPrice !== undefined ? parseFloat(aPrice) : Infinity;
            bValue = bPrice !== null && bPrice !== undefined ? parseFloat(bPrice) : Infinity;
            break;
          }
        case "cachedInputPrice":
          {
            var aPrice = a.provider.cachedInputPrice;
            var bPrice = b.provider.cachedInputPrice;
            aValue = aPrice !== null && aPrice !== undefined ? parseFloat(aPrice) : Infinity;
            bValue = bPrice !== null && bPrice !== undefined ? parseFloat(bPrice) : Infinity;
            break;
          }
        default:
          return 0;
      }
      if (aValue < bValue) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  }, [modelsWithProviders, sortField, sortDirection, filters.selectedProvider]);
  var hasActiveFilters = searchQuery || filters.category && filters.category !== defaultCategory || filters.tier && filters.tier !== "all" || Object.values(filters.capabilities).some(Boolean) || filters.selectedProvider && filters.selectedProvider !== "all" || filters.showDeactivated || filters.source && filters.source !== "all" || filters.eligibleOnly || filters.inputPrice.min || filters.inputPrice.max || filters.outputPrice.min || filters.outputPrice.max || filters.contextSize.min || filters.contextSize.max;
  var currentPage = Math.max(1, Math.floor(Number(searchParams.get("page")) || 1));
  var totalTablePages = Math.ceil(flattenedRows.length / MODELS_PER_PAGE);
  var totalGridPages = Math.ceil(modelsWithProviders.length / MODELS_PER_PAGE);
  var totalPages = viewMode === "table" ? totalTablePages : totalGridPages;
  var safePage = Math.min(currentPage, Math.max(1, totalPages));
  useEffect(function () {
    if (currentPage !== safePage) {
      updateUrlWithFilters({
        page: safePage > 1 ? String(safePage) : undefined
      });
    }
  }, [currentPage, safePage, updateUrlWithFilters]);
  var paginatedFlattenedRows = flattenedRows.slice((safePage - 1) * MODELS_PER_PAGE, safePage * MODELS_PER_PAGE);
  var paginatedModels = modelsWithProviders.slice((safePage - 1) * MODELS_PER_PAGE, safePage * MODELS_PER_PAGE);
  var goToPage = useCallback(function (page) {
    updateUrlWithFilters({
      page: page > 1 ? String(page) : undefined
    });
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [updateUrlWithFilters]);
  var buildPageUrl = useCallback(function (page) {
    var params = new URLSearchParams(searchParams.toString());
    if (page > 1) {
      params.set("page", String(page));
    } else {
      params.delete("page");
    }
    var qs = params.toString();
    return "".concat(pathname).concat(qs ? "?".concat(qs) : "");
  }, [pathname, searchParams]);
  var toggleRowExpanded = useCallback(function (rowKey) {
    setExpandedRows(function (prev) {
      var next = new Set(prev);
      if (next.has(rowKey)) {
        next.delete(rowKey);
      } else {
        next.add(rowKey);
      }
      return next;
    });
  }, []);
  var copyToClipboard = useCallback(function (text, key, e) {
    return __awaiter(_this, void 0, void 0, function () {
      var err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.stopPropagation();
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4, navigator.clipboard.writeText(text)];
          case 2:
            _a.sent();
            setCopiedModel(key);
            setTimeout(function () {
              return setCopiedModel(null);
            }, 2000);
            return [3, 4];
          case 3:
            err_1 = _a.sent();
            console.error("Failed to copy text:", err_1);
            return [3, 4];
          case 4:
            return [2];
        }
      });
    });
  }, []);
  var handleSort = function (field) {
    if (sortField === field) {
      var newDir = sortDirection === "asc" ? "desc" : "asc";
      setSortDirection(newDir);
      updateUrlWithFilters({
        sortDir: newDir
      });
    } else {
      setSortField(field);
      setSortDirection("asc");
      updateUrlWithFilters({
        sortField: field,
        sortDir: "asc"
      });
    }
  };
  var getSortIcon = function (field) {
    if (sortField !== field) {
      return _jsx(ArrowUpDown, {
        className: "ml-2 h-4 w-4 opacity-50"
      });
    }
    return sortDirection === "asc" ? _jsx(ArrowUp, {
      className: "ml-2 h-4 w-4 text-primary"
    }) : _jsx(ArrowDown, {
      className: "ml-2 h-4 w-4 text-primary"
    });
  };
  var shouldShowStabilityWarning = function (stability) {
    return stability !== null && stability !== undefined && ["unstable", "experimental"].includes(stability);
  };
  var formatPrice = function (price, discount) {
    if (price === null || price === undefined) {
      return "—";
    }
    var priceNum = parseFloat(price);
    var discountNum = discount ? parseFloat(discount) : 0;
    var originalPrice = (priceNum * 1e6).toFixed(2);
    if (discountNum > 0) {
      var discountedPrice = (priceNum * 1e6 * (1 - discountNum)).toFixed(2);
      return _jsxs("div", {
        className: "flex flex-col items-end",
        children: [_jsxs("div", {
          className: "flex items-center gap-1",
          children: [_jsxs("span", {
            className: "line-through text-muted-foreground text-xs",
            children: ["$", originalPrice]
          }), _jsxs("span", {
            className: "text-green-600 font-semibold",
            children: ["$", discountedPrice]
          })]
        }), _jsxs("span", {
          className: "text-[10px] text-green-600",
          children: ["-", Math.round(discountNum * 100), "% off"]
        })]
      });
    }
    return "$".concat(originalPrice);
  };
  var getCapabilityIcons = computeCapabilities;
  var clearFilters = function () {
    setSearchQuery("");
    setFilters({
      category: defaultCategory,
      tier: "all",
      capabilities: {
        streaming: false,
        vision: false,
        tools: false,
        reasoning: false,
        reasoningBudget: false,
        jsonOutput: false,
        jsonOutputSchema: false,
        imageGeneration: false,
        videoGeneration: false,
        audioGeneration: false,
        embedding: false,
        rerank: false,
        webSearch: false,
        free: false,
        discounted: false
      },
      selectedProvider: "all",
      showDeactivated: false,
      source: "all",
      eligibleOnly: false,
      inputPrice: {
        min: "",
        max: ""
      },
      outputPrice: {
        min: "",
        max: ""
      },
      contextSize: {
        min: "",
        max: ""
      }
    });
    setSortField(null);
    setSortDirection("asc");
    updateUrlWithFilters({
      q: undefined,
      category: undefined,
      tier: undefined,
      streaming: undefined,
      vision: undefined,
      tools: undefined,
      reasoning: undefined,
      reasoningBudget: undefined,
      jsonOutput: undefined,
      jsonOutputSchema: undefined,
      imageGeneration: undefined,
      videoGeneration: undefined,
      audioGeneration: undefined,
      embedding: undefined,
      webSearch: undefined,
      free: undefined,
      discounted: undefined,
      provider: undefined,
      deactivated: undefined,
      source: undefined,
      eligibility: undefined,
      inputPriceMin: undefined,
      inputPriceMax: undefined,
      outputPriceMin: undefined,
      outputPriceMax: undefined,
      contextSizeMin: undefined,
      contextSizeMax: undefined,
      sortField: undefined,
      sortDir: undefined
    });
  };
  var renderFilters = function () {
    return _jsx(Card, {
      className: "transition-all duration-200 ".concat(showFilters ? "opacity-100" : "opacity-0 hidden"),
      children: _jsx(CardContent, {
        className: "pt-6",
        children: _jsxs("div", {
          className: "grid gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6",
          children: [_jsxs("div", {
            className: "space-y-3",
            children: [!hideUseCaseFilter && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Use Case"
              }), _jsxs(Select, {
                value: filters.category,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      category: value
                    });
                  });
                  updateUrlWithFilters({
                    category: value !== defaultCategory ? value : undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All Use Cases"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "All Use Cases"]
                    })
                  }), _jsx(SelectItem, {
                    value: "code",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Code, {
                        className: "h-4 w-4 text-indigo-500"
                      }), "Code Generation"]
                    })
                  }), _jsx(SelectItem, {
                    value: "chat",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Bot, {
                        className: "h-4 w-4 text-blue-500"
                      }), "Chat & Assistants"]
                    })
                  }), _jsx(SelectItem, {
                    value: "reasoning",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Brain, {
                        className: "h-4 w-4 text-orange-500"
                      }), "Reasoning & Analysis"]
                    })
                  }), _jsx(SelectItem, {
                    value: "creative",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(PenTool, {
                        className: "h-4 w-4 text-purple-500"
                      }), "Creative & Writing"]
                    })
                  }), _jsx(SelectItem, {
                    value: "image",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(ImagePlus, {
                        className: "h-4 w-4 text-pink-500"
                      }), "Image Generation"]
                    })
                  }), _jsx(SelectItem, {
                    value: "multimodal",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Sparkles, {
                        className: "h-4 w-4 text-amber-500"
                      }), "Multimodal (Vision)"]
                    })
                  })]
                })]
              })]
            }), showPricingTierFilter ? _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Pricing Tier (DevPass)"
              }), _jsxs(Select, {
                value: filters.tier,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      tier: value
                    });
                  });
                  updateUrlWithFilters({
                    tier: value !== "all" ? value : undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All Tiers"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "All Tiers"]
                    })
                  }), _jsx(SelectItem, {
                    value: "premium",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Gem, {
                        className: "h-4 w-4 text-amber-500"
                      }), "Premium"]
                    })
                  }), _jsx(SelectItem, {
                    value: "standard",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Zap, {
                        className: "h-4 w-4 text-emerald-500"
                      }), "Standard"]
                    })
                  })]
                })]
              })]
            }) : null]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Capabilities"
            }), _jsx("div", {
              className: "flex flex-wrap gap-2",
              children: [{
                key: "streaming",
                label: "Streaming",
                icon: Zap,
                color: "text-blue-500"
              }, {
                key: "vision",
                label: "Vision",
                icon: Eye,
                color: "text-green-500"
              }, {
                key: "tools",
                label: "Tools",
                icon: Wrench,
                color: "text-purple-500"
              }, {
                key: "reasoning",
                label: "Reasoning",
                icon: MessageSquare,
                color: "text-orange-500"
              }, {
                key: "reasoningBudget",
                label: "Reasoning Budget",
                icon: Sliders,
                color: "text-amber-500"
              }, {
                key: "jsonOutput",
                label: "JSON",
                icon: Braces,
                color: "text-cyan-500"
              }, {
                key: "jsonOutputSchema",
                label: "Structured JSON",
                icon: FileJson2,
                color: "text-teal-500"
              }, {
                key: "imageGeneration",
                label: "Image Gen",
                icon: ImagePlus,
                color: "text-pink-500"
              }, {
                key: "videoGeneration",
                label: "Video Gen",
                icon: Video,
                color: "text-violet-500"
              }, {
                key: "audioGeneration",
                label: "Speech Gen",
                icon: Volume2,
                color: "text-rose-500"
              }, {
                key: "embedding",
                label: "Embeddings",
                icon: Boxes,
                color: "text-indigo-500"
              }, {
                key: "rerank",
                label: "Rerank",
                icon: ListOrdered,
                color: "text-amber-500"
              }, {
                key: "webSearch",
                label: "Web Search",
                icon: Globe,
                color: "text-sky-500"
              }, {
                key: "free",
                label: "Free",
                icon: Gift,
                color: "text-emerald-500"
              }, {
                key: "discounted",
                label: "Discounted",
                icon: Percent,
                color: "text-red-500"
              }].map(function (_a) {
                var key = _a.key,
                  label = _a.label,
                  Icon = _a.icon,
                  color = _a.color;
                return _jsxs(Toggle, {
                  variant: "outline",
                  size: "sm",
                  pressed: filters.capabilities[key],
                  onPressedChange: function (pressed) {
                    var _a;
                    setFilters(function (prev) {
                      var _a;
                      return __assign(__assign({}, prev), {
                        capabilities: __assign(__assign({}, prev.capabilities), (_a = {}, _a[key] = pressed, _a))
                      });
                    });
                    updateUrlWithFilters((_a = {}, _a[key] = pressed ? "true" : undefined, _a));
                  },
                  className: "gap-1.5",
                  children: [_jsx(Icon, {
                    className: "h-3.5 w-3.5 ".concat(color)
                  }), _jsx("span", {
                    className: "text-xs",
                    children: label
                  })]
                }, "".concat(key, "-").concat(label));
              })
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Provider"
            }), _jsxs(Select, {
              value: filters.selectedProvider,
              onValueChange: function (value) {
                setFilters(function (prev) {
                  return __assign(__assign({}, prev), {
                    selectedProvider: value
                  });
                });
                updateUrlWithFilters({
                  provider: value === "all" ? undefined : value
                });
              },
              children: [_jsx(SelectTrigger, {
                className: "w-full",
                children: _jsx(SelectValue, {
                  placeholder: "All providers"
                })
              }), _jsxs(SelectContent, {
                children: [_jsx(SelectItem, {
                  value: "all",
                  children: "All providers"
                }), providers.map(function (provider) {
                  var ProviderIcon = getProviderIcon(provider.id);
                  return _jsx(SelectItem, {
                    value: provider.id,
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [ProviderIcon && _jsx(ProviderIcon, {
                        className: "h-4 w-4"
                      }), _jsx("span", {
                        children: provider.name
                      })]
                    })
                  }, "".concat(provider.id, "-").concat(provider.name));
                })]
              })]
            }), hasCustomModels && _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "font-medium text-sm",
                children: "Source"
              }), _jsxs(Select, {
                value: filters.source,
                onValueChange: function (value) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      source: value
                    });
                  });
                  updateUrlWithFilters({
                    source: value === "all" ? undefined : value,
                    page: undefined
                  });
                },
                children: [_jsx(SelectTrigger, {
                  className: "w-full",
                  children: _jsx(SelectValue, {
                    placeholder: "All models"
                  })
                }), _jsxs(SelectContent, {
                  children: [_jsx(SelectItem, {
                    value: "all",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(List, {
                        className: "h-4 w-4 text-muted-foreground"
                      }), "Catalog & custom"]
                    })
                  }), _jsx(SelectItem, {
                    value: "catalog",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Boxes, {
                        className: "h-4 w-4 text-indigo-500"
                      }), "Catalog models"]
                    })
                  }), _jsx(SelectItem, {
                    value: "custom",
                    children: _jsxs("div", {
                      className: "flex items-center gap-2",
                      children: [_jsx(Wrench, {
                        className: "h-4 w-4 text-emerald-500"
                      }), "Custom models"]
                    })
                  })]
                })]
              })]
            }), _jsx("div", {
              className: "font-medium text-sm",
              children: "Status"
            }), _jsxs("div", {
              className: "flex flex-wrap gap-2",
              children: [_jsxs(Toggle, {
                variant: "outline",
                size: "sm",
                pressed: filters.showDeactivated,
                onPressedChange: function (pressed) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      showDeactivated: pressed
                    });
                  });
                  updateUrlWithFilters({
                    deactivated: pressed ? "true" : undefined,
                    page: undefined
                  });
                },
                className: "gap-1.5",
                children: [_jsx(AlertCircle, {
                  className: "h-3.5 w-3.5 text-red-500"
                }), _jsx("span", {
                  className: "text-xs",
                  children: "Show deactivated"
                })]
              }), hasBlockedMappings && _jsxs(Toggle, {
                variant: "outline",
                size: "sm",
                pressed: filters.eligibleOnly,
                onPressedChange: function (pressed) {
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      eligibleOnly: pressed
                    });
                  });
                  updateUrlWithFilters({
                    eligibility: pressed ? "eligible" : undefined,
                    page: undefined
                  });
                },
                className: "gap-1.5",
                children: [_jsx(Check, {
                  className: "h-3.5 w-3.5 text-emerald-500"
                }), _jsx("span", {
                  className: "text-xs",
                  children: "Eligible only"
                })]
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Input Price ($/M tokens)"
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min price",
                type: "number",
                value: filters.inputPrice.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      inputPrice: __assign(__assign({}, prev.inputPrice), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    inputPriceMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max price",
                type: "number",
                value: filters.inputPrice.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      inputPrice: __assign(__assign({}, prev.inputPrice), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    inputPriceMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Output Price ($/M tokens)"
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min price",
                type: "number",
                value: filters.outputPrice.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      outputPrice: __assign(__assign({}, prev.outputPrice), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    outputPriceMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max price",
                type: "number",
                value: filters.outputPrice.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      outputPrice: __assign(__assign({}, prev.outputPrice), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    outputPriceMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            })]
          }), _jsxs("div", {
            className: "space-y-3",
            children: [_jsx("div", {
              className: "font-medium text-sm",
              children: "Context Size (tokens)"
            }), _jsxs("div", {
              className: "space-y-2",
              children: [_jsx(Input, {
                placeholder: "Min size (e.g., 128000)",
                type: "number",
                value: filters.contextSize.min,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      contextSize: __assign(__assign({}, prev.contextSize), {
                        min: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    contextSizeMin: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              }), _jsx(Input, {
                placeholder: "Max size (e.g., 200000)",
                type: "number",
                value: filters.contextSize.max,
                onChange: function (e) {
                  var value = e.target.value;
                  setFilters(function (prev) {
                    return __assign(__assign({}, prev), {
                      contextSize: __assign(__assign({}, prev.contextSize), {
                        max: value
                      })
                    });
                  });
                  updateUrlWithFilters({
                    contextSizeMax: value !== null && value !== void 0 ? value : undefined
                  });
                },
                className: "h-8"
              })]
            })]
          })]
        })
      })
    });
  };
  var renderTableView = function () {
    return _jsx("div", {
      className: "rounded-md border",
      children: _jsx("div", {
        className: "relative w-full overflow-x-auto",
        children: _jsxs(Table, {
          children: [_jsx(TableHeader, {
            className: "top-0 z-10 bg-background/95 backdrop-blur",
            children: _jsxs(TableRow, {
              children: [_jsx(TableHead, {
                className: "w-[180px] bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("provider");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent justify-start uppercase text-xs tracking-wider",
                  children: ["Provider", getSortIcon("provider")]
                })
              }), _jsx(TableHead, {
                className: "w-[280px] bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("name");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent justify-start uppercase text-xs tracking-wider",
                  children: ["Model ID", getSortIcon("name")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("inputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Input $/M", getSortIcon("inputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("outputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Output $/M", getSortIcon("outputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-right bg-background/95 backdrop-blur-sm border-b",
                children: _jsxs(Button, {
                  variant: "ghost",
                  onClick: function () {
                    return handleSort("cachedInputPrice");
                  },
                  className: "h-auto p-0 font-semibold hover:bg-transparent uppercase text-xs tracking-wider",
                  children: ["Cache Read $/M", getSortIcon("cachedInputPrice")]
                })
              }), _jsx(TableHead, {
                className: "text-center bg-background/95 backdrop-blur-sm border-b uppercase text-xs tracking-wider font-semibold",
                children: "Features"
              })]
            })
          }), _jsx(TableBody, {
            children: paginatedFlattenedRows.map(function (row) {
              return _jsx(ModelTableRow, {
                row: row,
                isExpanded: expandedRows.has(row.rowKey),
                copiedModel: copiedModel,
                onToggleExpand: function () {
                  return toggleRowExpanded(row.rowKey);
                },
                onCopy: copyToClipboard,
                onNavigate: function () {
                  if (row.model.source === "custom") {
                    return;
                  }
                  var url = modelHref("/models/".concat(encodeURIComponent(row.model.id), "/").concat(row.provider.providerId));
                  if (modelHrefBase) {
                    window.open(url, "_blank");
                  } else {
                    router.push(url);
                  }
                },
                formatPrice: formatPrice,
                modelHref: modelHref
              }, row.rowKey);
            })
          })]
        })
      })
    });
  };
  var renderGridView = function () {
    return _jsx("div", {
      className: "grid gap-6 md:grid-cols-2 lg:grid-cols-3",
      children: paginatedModels.map(function (model) {
        var _a;
        return _jsx(ModelCard, {
          shouldShowStabilityWarning: shouldShowStabilityWarning,
          getCapabilityIcons: getCapabilityIcons,
          model: model,
          goToModel: function () {
            if (model.source === "custom") {
              return;
            }
            var url = modelHref("/models/".concat(encodeURIComponent(model.id)));
            if (modelHrefBase) {
              window.open(url, "_blank");
            } else {
              router.push(url);
            }
          },
          formatPrice: formatPrice,
          renderCta: renderCta
        }, "".concat(model.id, "-").concat(model.providerDetails[0].provider.providerId, "-").concat((_a = model.providerDetails[0].provider.region) !== null && _a !== void 0 ? _a : ""));
      })
    });
  };
  return _jsxs("div", {
    className: "min-h-screen text-foreground bg-background",
    children: [totalPages > 1 && _jsxs(_Fragment, {
      children: [safePage > 1 && _jsx("link", {
        rel: "prev",
        href: buildPageUrl(safePage - 1)
      }), safePage < totalPages && _jsx("link", {
        rel: "next",
        href: buildPageUrl(safePage + 1)
      })]
    }), _jsxs("main", {
      children: [children, _jsx("div", {
        className: cn("container mx-auto px-4 pb-8 space-y-6", {
          "pt-40": children
        }),
        children: _jsx(TooltipProvider, {
          delayDuration: 300,
          skipDelayDuration: 100,
          children: _jsxs("div", {
            className: "container mx-auto py-8 space-y-6",
            children: [!hideHeader && _jsxs("div", {
              className: "flex items-start md:items-center justify-between flex-col md:flex-row gap-4",
              children: [_jsxs("div", {
                children: [_jsx("h1", {
                  className: "text-3xl font-bold",
                  children: title !== null && title !== void 0 ? title : "Models"
                }), _jsx("p", {
                  className: "text-muted-foreground mt-2",
                  children: description !== null && description !== void 0 ? description : "Comprehensive list of all supported models and their providers"
                })]
              }), _jsxs("div", {
                className: "flex items-center gap-2",
                children: [_jsx(Link, {
                  href: "https://docs.llmgateway.io/v1_models",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: _jsxs(Button, {
                    variant: "outline",
                    size: "sm",
                    children: [_jsx(ExternalLink, {
                      className: "h-4 w-4 mr-1"
                    }), "API Docs"]
                  })
                }), _jsx(Button, {
                  size: "sm",
                  asChild: true,
                  children: _jsxs(Link, {
                    href: modelHref("/models/compare"),
                    children: [_jsx(Scale, {
                      className: "h-4 w-4 mr-1"
                    }), "Compare"]
                  })
                })]
              })]
            }), _jsxs("div", {
              className: "flex flex-col gap-4",
              children: [_jsxs("div", {
                className: "flex items-center gap-4",
                children: [_jsxs("div", {
                  className: "relative flex-1 max-w-sm",
                  children: [_jsx(Search, {
                    className: "absolute left-2 top-2.5 h-4 w-4 text-muted-foreground"
                  }), _jsx(Input, {
                    placeholder: "Search models...",
                    value: searchQuery,
                    onChange: function (e) {
                      var value = e.target.value;
                      setSearchQuery(value);
                      updateUrlWithFilters({
                        q: value !== null && value !== void 0 ? value : undefined
                      });
                    },
                    className: "pl-8"
                  })]
                }), _jsxs(Button, {
                  variant: "outline",
                  size: "sm",
                  onClick: function () {
                    var next = !showFilters;
                    setShowFilters(next);
                    updateUrlWithFilters({
                      filters: next ? "1" : undefined
                    });
                  },
                  className: hasActiveFilters ? "border-primary text-primary" : "",
                  children: [_jsx(Filter, {
                    className: "h-4 w-4 mr-1"
                  }), "Filters", hasActiveFilters && _jsx(Badge, {
                    variant: "secondary",
                    className: "ml-2 px-1 py-0 text-xs",
                    children: [searchQuery ? 1 : 0, filters.category && filters.category !== defaultCategory ? 1 : 0, filters.tier && filters.tier !== "all" ? 1 : 0, filters.selectedProvider && filters.selectedProvider !== "all" ? 1 : 0, Object.values(filters.capabilities).filter(Boolean).length, filters.showDeactivated ? 1 : 0, filters.source && filters.source !== "all" ? 1 : 0, filters.eligibleOnly ? 1 : 0, [filters.inputPrice.min, filters.inputPrice.max].filter(Boolean).length, [filters.outputPrice.min, filters.outputPrice.max].filter(Boolean).length, [filters.contextSize.min, filters.contextSize.max].filter(Boolean).length].reduce(function (a, b) {
                      return a + b;
                    }, 0)
                  })]
                }), hasActiveFilters && _jsxs(Button, {
                  variant: "ghost",
                  size: "sm",
                  onClick: clearFilters,
                  children: [_jsx(X, {
                    className: "h-4 w-4 mr-1"
                  }), "Clear"]
                })]
              }), renderFilters()]
            }), _jsxs("div", {
              className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4",
              children: [_jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: hasActiveFilters ? "".concat(modelsWithProviders.length, "/").concat(totalModelCount) : modelsWithProviders.length
                  }), _jsx("div", {
                    className: "text-sm text-muted-foreground",
                    children: "Models"
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: hasActiveFilters ? "".concat(filteredProviderCount, "/").concat(totalProviderCount) : totalProviderCount
                  }), _jsx("div", {
                    className: "text-sm text-muted-foreground",
                    children: "Providers"
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m) {
                      return m.providerDetails.some(function (p) {
                        return p.provider.vision;
                      });
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Vision Models", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m_0) {
                      return m_0.providerDetails.some(function (p_0) {
                        return p_0.provider.tools;
                      });
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Tool-enabled", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              }), _jsx(Card, {
                children: _jsxs(CardContent, {
                  children: [_jsx("div", {
                    className: "text-2xl font-bold",
                    children: modelsWithProviders.filter(function (m_1) {
                      return m_1.free;
                    }).length
                  }), _jsxs("div", {
                    className: "text-sm text-muted-foreground",
                    children: ["Free Models", hasActiveFilters ? " (filtered)" : ""]
                  })]
                })
              })]
            }), _jsxs("div", {
              className: "flex items-center gap-2",
              children: [_jsxs(Button, {
                variant: viewMode === "table" ? "default" : "outline",
                size: "sm",
                onClick: function () {
                  setViewMode("table");
                  updateUrlWithFilters({
                    view: "table"
                  });
                },
                children: [_jsx(List, {
                  className: "h-4 w-4 mr-1"
                }), "Table"]
              }), _jsxs(Button, {
                variant: viewMode === "grid" ? "default" : "outline",
                size: "sm",
                onClick: function () {
                  setViewMode("grid");
                  updateUrlWithFilters({
                    view: "grid"
                  });
                },
                children: [_jsx(Grid, {
                  className: "h-4 w-4 mr-1"
                }), "Grid"]
              })]
            }), viewMode === "table" ? renderTableView() : renderGridView(), totalPages > 1 && _jsxs("nav", {
              "aria-label": "Pagination",
              className: "flex items-center justify-center gap-2 pt-4",
              children: [_jsxs(Button, {
                variant: "outline",
                size: "sm",
                disabled: safePage <= 1,
                onClick: function () {
                  return goToPage(safePage - 1);
                },
                children: [_jsx(ChevronLeft, {
                  className: "h-4 w-4 mr-1"
                }), "Previous"]
              }), _jsxs("span", {
                className: "text-sm text-muted-foreground px-2",
                children: ["Page ", safePage, " of ", totalPages]
              }), _jsxs(Button, {
                variant: "outline",
                size: "sm",
                disabled: safePage >= totalPages,
                onClick: function () {
                  return goToPage(safePage + 1);
                },
                children: ["Next", _jsx(ChevronRight, {
                  className: "h-4 w-4 ml-1"
                })]
              })]
            })]
          })
        })
      }), seoContent]
    }), footer]
  });
}